<template>
  <div class="select-first-town">
    <p class="popup-header">新建城镇</p>

    <div class="faction-list h-outer-border around-4 bz0 h-bg brown-2">
      <div class="faction-item h-outer-border around-4 bw2 bz0"
           :class="[selectedFaction === factionName ? 'selected' : '', factionName ? 'h-title nowrap' : '']"
           :data-title="FACTION_CONF.FACTION_ENG_CH[factionName] || ''"
           v-for="factionName in [...FACTION_CONF.FACTIONS, null, null]"
           v-click-sound-button="Boolean(factionName)"
           @click="handleSelectFaction(factionName)">
        <img :src="`${$rHost}/img/common/race/${factionName}.jpg`" alt="">
      </div>
    </div>
    <p class="faction-intro">大人，新建城镇所需资源如下：</p>

    <div class="create-cost">
      <div class="cost-list h-outer-border around-4 bw2 bz0 h-bg brown-2">
        <div class="cost-item" v-for="item in resourceMaps">
          <img :src="resourceUrl(item.fileName)" alt="">
          <p class="cost"
             :class="{ 'not-enough': !isResourceEnough(item.name) }">
            {{ townResourceData[item.name] }}
          </p>
        </div>
      </div>
    </div>

    <div class="h-line separator"></div>

    <div class="footer">
      <button v-click-sound-button
              type="button"
              :disabled="submitLoading || !isAllResourceEnough"
              class="h-btn primary"
              @click="submit">
        确认选择
      </button>
      <button v-click-sound-button
              type="button"
              class="h-btn primary"
              @click="closePopup">
        取消
      </button>
    </div>
  </div>
</template>

<script>
  import FACTION_CONF from '@js/config/faction'
  import factionIntro from './faction-intro'
  import API from '@js/api'
  import { mapGetters } from 'vuex'

  const resourceMaps = [
    {
      name: 'crystal',
      nameCn: '水晶',
      fileName: 'SMALRES4',
    },
    {
      name: 'gem',
      nameCn: '宝石',
      fileName: 'SMALRES5',
    },
    {
      name: 'mercury',
      nameCn: '水银',
      fileName: 'SMALRES1',
    },
    {
      name: 'sulfur',
      nameCn: '硫磺',
      fileName: 'SMALRES3',
    },
    {
      name: 'wood',
      nameCn: '木材',
      fileName: 'SMALRES0',
    },
    {
      name: 'ore',
      nameCn: '矿石',
      fileName: 'SMALRES2',
    },
    {
      name: 'gold',
      nameCn: '黄金',
      fileName: 'AVTGOLD0',
    },
  ]

  export default {
    name: 'create-town',

    data () {
      return {
        FACTION_CONF,
        factionIntro,
        selectedFaction: FACTION_CONF.INITIAL_FACTIONS[0],
        resourceMaps,
        submitLoading: false,
        townResourceData: {
          gold: 8000000, wood: 4000, ore: 4000,
          crystal: 1500, gem: 1500, mercury: 1500, sulfur: 1500,
        }
      }
    },

    computed: {
      ...mapGetters('hero', [
        'gold',
        'wood',
        'ore',
        'crystal',
        'gem',
        'mercury',
        'sulfur',
      ]),

      isAllResourceEnough () {
        return resourceMaps.every((item) => {
          return this[item.name] >= this.townResourceData[item.name]
        })
      },
    },

    methods: {
      resourceUrl (name) {
        return `${this.$rHost}/img/common/resource/${name}.png`
      },

      isResourceEnough (name) {
        return this[name] >= this.townResourceData[name]
      },

      handleSelectFaction (faction) {
        if (!faction) {
          return
        }
        this.selectedFaction = faction
      },

      async submit () {
        try { const confirm = await this.$confirm(`即将新建城镇【${FACTION_CONF.FACTION_ENG_CH[this.selectedFaction]}】，请确认。`)
          if (!confirm) {
            return
          }

          this.submitLoading = true
          await API.town.createTown({
            town: FACTION_CONF.FACTIONS_VALUE[this.selectedFaction]
          })
          this.$emit('created')
        } catch (err) {
          console.error(err)
          this.$message(err.message)
        } finally {
          this.submitLoading = false
        }
      },

      closePopup () {
        this.$emit('close')
      },
    },
  }
</script>

<style lang="stylus" scoped>
  .select-first-town
    width 400px

  .faction-list
    display flex
    flex-wrap wrap
    justify-content space-between
    padding 8px 8px 3px
    .faction-item
      margin-bottom 5px
      display flex
      justify-content center
      align-items center
      padding 2px
      width 90px
      height 60px
      > img
        height 100%
        filter grayscale(75%)
      &:hover
        > img
          filter grayscale(35%)
      &.selected
        outline 2px solid $colorLightBlue
        > img
          filter grayscale(0)

  .faction-intro
    padding 5px
    goldText1()
    height 30px
    line-height 20px
    font-size 12px
    letter-spacing 1px
    text-align center

  .h-line
    margin-top 5px

  .footer
    padding-bottom 5px
    text-align center
    display flex
    justify-content space-between
    .h-btn
      width 150px
      height 36px
      line-height 36px
      font-size 18px
      text-shadow 1px 1px 0 #fff

  .create-cost
    width 100%
    display flex
    flex-direction column
    justify-content space-between
    .cost-list
      display flex
      justify-content space-evenly
      align-items center
      flex-wrap wrap
      padding 5px
      height 75px
    .cost-item
      width 14%
      text-align center
      &:last-child
        width 16%
      > img
        height 30px
        vertical-align top
      .cost
        margin-top 5px
        whiteText1()
        text-align center
        font-size 12px
        font-weight bold
        letter-spacing 1px
      .not-enough
        color $colorRed1

</style>
